import React, { useState, useEffect } from "react";

const UserContext = React.createContext();

function UserProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

    useEffect(() => {
        fetch(`${API_URL}/me`, {
            credentials: 'include'
        })
            .then((response) => {
                if (response.ok) {
                    return response.json().then(setUser);
                } else if (response.status === 401 || response.status === 403) {
                    // Session expired or invalid - just clear user (no redirect)
                    // App.js routing will handle showing appropriate page
                    setUser(null);
                } else {
                    // Other errors - clear user to be safe
                    setUser(null);
                }
            })
            .catch((error) => {
                console.error('Failed to fetch user session:', error);
                setUser(null);
            })
            .finally(() => setLoading(false));
    }, [API_URL]);

    return (
        <UserContext.Provider value={{ user, setUser, loading }}>
            {children}
        </UserContext.Provider>
    );
}

export { UserContext, UserProvider };